// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"bz_a bhj_h bhj_ka bhj_ux bhj_ro bhj_un bhj_rq bhj_rh"};